import { FETCH_AIRPORT_INFORMATION, FETCH_RUNWAY_CONDITIONS, FETCH_USEFULLINKS, SAVE_NOTAMS, SAVE_WEATHER_DATA } from './types';

export const saveNotams = data => ({
  type: SAVE_NOTAMS,
  payload: data
});

export const fetchAirportInfo = data => ({
  type: FETCH_AIRPORT_INFORMATION,
  payload: data
});

export const fetchRunwayInfo = (data, tileOrder) => ({
  type: FETCH_RUNWAY_CONDITIONS,
  payload: { data, tileOrder }
});

export const fetchUsefulLinks = data => ({
  type: FETCH_USEFULLINKS,
  payload: data
});

export const saveWeatherData = data => ({
  type: SAVE_WEATHER_DATA,
  payload: data
});
